import axios from 'axios';

import { TimeFilter } from '@tallo/utility';

import { CancelShowingDto } from '../interfaces/cancel-showing.interface';
import { RescheduleShowingDto } from '../interfaces/reschedule-showing.interface';
import { RescheduledShowingDto } from '../interfaces/rescheduled-showing.dto';
import { ShowingStatus } from '../interfaces/showing-status.enum';
import { ShowingDto } from '../interfaces/showing.interface';

class ShowingService {
  async get(showingId: string): Promise<ShowingDto> {
    const response = await axios.get(`showing/${showingId}`);

    return response.data;
  }

  async getShowingsByCompany(
    companyId: string,
    params: {
      timeFilter?: TimeFilter;
      onlyWithPendingShowingReqests?: boolean;
      propertyId?: string;
      renterId?: string;
      status?: ShowingStatus;
      /** One page of the list, in its order; leave both out for the whole list */
      limit?: number;
      offset?: number;
    } = {},
  ): Promise<ShowingDto[]> {
    const response = await axios.get(`showing/company/${companyId}`, { params });

    return response.data;
  }

  async reschedule(showingId: string, payload: RescheduleShowingDto): Promise<RescheduledShowingDto> {
    const response = await axios.post(`showing/${showingId}/reschedule`, payload);

    return response.data;
  }

  async cancel(showingId: string, payload: CancelShowingDto): Promise<void> {
    await axios.post(`showing/${showingId}/cancel`, payload);
  }

  async assignAgent(showingId: string, showingAgentId: string): Promise<void> {
    await axios.post(`showing/${showingId}/assign-showing-agent`, { showingAgentId });
  }

  async markCompletedByProperty(propertyId: string, renterEmail: string): Promise<void> {
    await axios.put('showing/mark-completed/by-property', { propertyId, renterEmail });
  }
}

export default new ShowingService();
